import React from "react";
import AntdRow from 'antd/lib/row';

const Row = (props) => <AntdRow {...props} />

export default Row;



// WEBPACK FOOTER //
// ./src/components/row/index.tsx